import React, { useMemo, memo } from 'react';

import { getResourceTo } from 'react/utils/utils';
import InfoIcon from 'static/images/sidebar/info.svg';

function InfoVersion() {
  const { liveVersion, greenmileVersion, fullLiveVersion } = useMemo(() => {
    const { GMLSemanticVersion, GMLVersionName, GMSVersionName } = App.Version;

    const parsedLiveVersion = getResourceTo('sidebarMenu.version.LiveVersion')
      .replace('@versionText@', GMLSemanticVersion);
    const parsedGreenmileVersion = getResourceTo('sidebarMenu.version.ServerVersion')
      .replace('@versionText@', GMSVersionName);

    return {
      liveVersion: parsedLiveVersion,
      fullLiveVersion: GMLVersionName,
      greenmileVersion: parsedGreenmileVersion
    };
  }, []);

  const handleClickInfoIcon = () => {
    new Monet.UI.Help().logIn();
  };

  return (
    <div className="info-container">
      <img src={InfoIcon} alt="Info icon" onClick={handleClickInfoIcon} />
      <div className="text">
        <p title={fullLiveVersion}>{liveVersion}</p>
        <p title={greenmileVersion}>{greenmileVersion}</p>
      </div>
    </div>
  );
}

export default memo(InfoVersion);
